import { useTranslation } from 'react-i18next'

import type { UserResponse } from '@/api/responses'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui'

import { SettingRow } from './SettingRow'

export interface AccountCardProps {
  readonly user: UserResponse
}

/**
 * Card da Conta (read-only): nome e e-mail do usuário logado, expostos a partir da sessão já em
 * cache (`useSession`). Sem edição — o backend não oferece endpoint de perfil hoje.
 */
export function AccountCard({ user }: AccountCardProps) {
  const { t } = useTranslation()

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('settings.account.title')}</CardTitle>
        <CardDescription>{t('settings.account.description')}</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-3 text-sm">
        <SettingRow label={t('settings.account.nameLabel')} value={user.displayName} />
        <SettingRow label={t('settings.account.emailLabel')} value={user.email} />
      </CardContent>
    </Card>
  )
}
